export const setOnlinerAttrs = (list, row) => {
  const exist = list.find(item => item.userid === row.uid)
  if (exist) {
    return Object.assign(row, { roomId: exist.roomid, deviceType: exist.devicetype })
  }
  return row
}

export const onlineToTop = list => {
  return list.sort((a, b) => Number(b.deviceType || 0) - Number(a.deviceType || 0))
}
